/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespFollowSearchBanner_user$ref = any;
type SbRespFollowSearchTopButton_user$ref = any;
type SbRespNullSearchResults_user$ref = any;
type SbRespRefineMenu_user$ref = any;
type SbRespSearchResultContainer_user$ref = any;
type SbSharedFollowSearchProvider_user$ref = any;
type SbSharedRelatedItems_user$ref = any;
type SharedRecentlyViewedItems_user$ref = any;
type TradePromo_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespComponents_user$ref: FragmentReference;
export type SbRespComponents_user = {|
  +canShowSellerName: ?boolean,
  +canShowInternalSellerName: ?boolean,
  +$fragmentRefs: TradePromo_user$ref & SbRespRefineMenu_user$ref & SbRespNullSearchResults_user$ref & SbRespFollowSearchBanner_user$ref & SbRespFollowSearchTopButton_user$ref & SbRespSearchResultContainer_user$ref & SbSharedFollowSearchProvider_user$ref & SbSharedRelatedItems_user$ref & SharedRecentlyViewedItems_user$ref,
  +$refType: SbRespComponents_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespComponents_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "canShowSellerName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "canShowInternalSellerName",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "VIEW_SELLER_NAME",
          "type": "String!"
        }
      ],
      "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchTopButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_user",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b2f1f9dc4ef4764bfab933446e88763d';
module.exports = node;
